// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__bF4ye","wrapper":"Loader_wrapper__9ErlA","image":"Loader_image__PTb1i","progress":"Loader_progress__0aunN"};